<template>
    <div class="kgk-run-create">
        <button v-if="showRunButton" type="button" @click.prevent="createRunButton()">
            <i class="fas fa-plus"></i>
            <span class="button-text">Neuen Lauf eintragen</span>
        </button>
        <button v-if="showStepsButton" type="button" @click.prevent="createRunStepsButton()">
            <i class="fas fa-plus"></i>
            <span class="button-text">Neue Schritte eintragen</span>
        </button>
    </div>
</template>

<script>
    import user from '../../api/user';
import CreateRunForm from './CreateRunForm';
    import CreateRunStepsForm from './CreateRunStepsForm';

    export default {
        name: 'CreateRun',
        props: ['user'],
        data() {
            return {

            }
        },
        computed: {
            // Before an explicit choice (run_mode === null/undefined) both
            // buttons stay available -- only once the user has picked a mode
            // in their profile does this narrow down to just that one.
            showRunButton() {
                return this.user.run_mode === null || typeof this.user.run_mode === 'undefined' || this.user.run_mode === 0;
            },
            showStepsButton() {
                return this.user.run_mode === null || typeof this.user.run_mode === 'undefined' || this.user.run_mode === 1;
            },
        },
        methods: {
            createRunButton() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Speichern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    }
                };

                this.$modal.show('dialog', {
                    title: 'Lauf eintragen',
                    component: CreateRunForm,
                    props: {
                        edit: false,
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger
                    },
                    on: {
                        created: _this.handleCreated,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            createRunStepsButton() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Speichern';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    }
                };

                this.$modal.show('dialog', {
                    title: 'Schritte eintragen',
                    component: CreateRunStepsForm,
                    props: {
                        edit: false,
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                        user: this.$parent.$parent.$parent.user
                    },
                    on: {
                        created: _this.handleCreated,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handleCreated() {
                //console.log('handleSelection', selectedUsers, this);
                //this.selection = selectedUsers;

                this.$modal.hide('dialog');

                this.$emit('created');
            },
        },
        mounted() {

        }
    }
</script>
